import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IDoctorFiltersParams } from '@project/data-providers';
import { IProfileTag } from '@project/view-models';
import { combineLatest } from 'rxjs';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { EDoctorsModuleAction, DoctorInviteManagerService } from '../doctor-invite-manager.service';

@Component({
  selector: 'app-doctor-invite-control',
  templateUrl: './doctor-invite-control.component.html',
  styleUrls: ['./doctor-invite-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DoctorInviteControlComponent {
  public readonly actions = EDoctorsModuleAction;
  public readonly filters$: Observable<Partial<IDoctorFiltersParams>> = this.doctorInviteManagerService.filtersState$;

  constructor(private doctorInviteManagerService: DoctorInviteManagerService) {
    this.doctorInviteManagerService.dispatchAction(EDoctorsModuleAction.LoadProfileTags);
  }

  public readonly profileTags$ = this.doctorInviteManagerService.profileTags$;
  public readonly selectedTag$ = combineLatest([this.profileTags$, this.doctorInviteManagerService.filtersState$]).pipe(
    map(([tags, filters]) => {
      const { tag } = filters;
      if (!tag) {
        return null;
      }
      return tags.find((t) => t.id === tag);
    }),
  );

  public openNewTagCreations() {
    this.doctorInviteManagerService.dispatchAction(EDoctorsModuleAction.OpenTagCreationSettings);
  }

  public setTagToDoctor(tag: IProfileTag) {
    const filters: Partial<IDoctorFiltersParams> = { tag: tag?.id };
    this.doctorInviteManagerService.dispatchAction(EDoctorsModuleAction.PatchFilters, filters);
  }
}
